import React from 'react';

const TranscriptionSettings = ({ settings, updateSettings, languages }) => {
  return (
    <div>
      <h3 className="text-sm font-semibold text-zinc-300 mb-3">Transcription</h3>
      <div className="space-y-3">
        <label className="flex items-center gap-2 cursor-pointer group">
          <input
            type="checkbox"
            checked={settings.translate}
            onChange={(e) => updateSettings({translate: e.target.checked})}
            className="w-4 h-4 accent-orange-500 cursor-pointer"
          />
          <span className="text-white group-hover:text-orange-400 transition-colors text-sm">
            Enable Translation
          </span>
        </label>

        <label className="flex items-center gap-2 cursor-pointer group">
          <input
            type="checkbox"
            checked={settings.diarise}
            onChange={(e) => updateSettings({diarise: e.target.checked})}
            className="w-4 h-4 accent-orange-500 cursor-pointer"
          />
          <span className="text-white group-hover:text-orange-400 transition-colors text-sm">
            Speaker Diarisation
          </span>
        </label>

        <div>
          <label className="block text-xs text-zinc-300 mb-2">Source Language</label>
          <select
            value={settings.sourceLang}
            onChange={(e) => updateSettings({sourceLang: e.target.value})}
            className="w-full px-3 py-2 glass-panel rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 cursor-pointer"
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code} className="bg-zinc-900">
                {lang.name}
              </option>
            ))}
          </select>
        </div>

        {settings.translate && (
          <div>
            <label className="block text-xs text-zinc-300 mb-2">Target Language</label>
            <select
              value={settings.targetLang}
              onChange={(e) => updateSettings({targetLang: e.target.value})}
              className="w-full px-3 py-2 glass-panel rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 cursor-pointer"
            >
              {languages.map((lang) => (
                <option key={lang.code} value={lang.code} className="bg-zinc-900">
                  {lang.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default TranscriptionSettings;
